/**
 * Labstep
 *
 * @module components/Entity/Form/fields
 * @desc Entity fields
 */

import { FieldType } from 'labstep-web/constants/form';
import type {
  FieldWithoutActionProps,
  IFieldTypeSearchSelectProps,
} from 'labstep-web/core/Form/Reusable/types';
import { getPlaceholder } from 'labstep-web/core/Select/Search/utils';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import rules from 'labstep-web/services/validation/rules';

export const fieldEntityName = (
  entityName: string,
): FieldWithoutActionProps => ({
  fieldType: FieldType.Text,
  fieldLabel: 'Name',
  name: 'name',
  validation: rules.resource.name,
  placeholder: `Give your ${getHumanReadableEntityName(
    entityName,
  )} a name`,
  header: true,
});

export const fieldEntityDescription = (
  entityName: string,
): FieldWithoutActionProps => ({
  fieldType: FieldType.TextArea,
  fieldLabel: 'Description',
  name: 'description',
  validation: rules.entity.description,
  placeholder: `Give your ${getHumanReadableEntityName(
    entityName,
  )} a description`,
  header: true,
});

export const fieldEntityTemplate = (
  entityName: string,
): IFieldTypeSearchSelectProps => ({
  elementProps: {
    entityName,
    openMenuOnFocus: true,
    creatable: true,
    createBody: {
      is_template: true,
    },
    extraParams: { is_template: 1 },
  },
  name: 'template',
  placeholder: getPlaceholder(entityName, true, true),
  fieldType: FieldType.SearchSelect,
  fieldLabel: getHumanReadableEntityName(
    entityName,
    false,
    true,
    true,
  ),
  validation: rules.resource.resource_template,
});
